import React from 'react'
import PopularPlayers from './PopularPlayers'
import PopularCountries from './PopularCountries'
import DashboardChallenges from './DashboardChallenges'
import DashboardSearchedPositions from './DashboardSearchedPositions'
import DashboardGeneralStats from './DashboardGeneralStats'
import DashboardSkills from './DashboardSkills'
import './dashboard.css'

/*
 * Two panels per row, paired by the question they answer.
 *
 *   who are the best players    Skills            Popular Players
 *   where is the demand         Searched Positions  Top Countries
 *   what is running now         Challenges
 *
 * Skills leads because it is the first thing a scout looks for, and it sits
 * next to Popular Players so the two rankings — earned points and rated
 * ability — can be read against each other without scrolling.
 */
export default function Dashboard() {
  return (
    <div className="dash-canvas">

      <DashboardGeneralStats/>

      <div className="grid grid-2">
        <DashboardSkills/>
        <PopularPlayers/>
      </div>

      <div className="grid grid-2">
        <DashboardSearchedPositions/>
        <PopularCountries/>
      </div>

      <DashboardChallenges/>

    </div>
  )
}
